import { useSelect } from '@refinedev/antd';
import { Select } from 'antd';
import { ISitter } from '../../interfaces/sitter';

type Props = {
  id?: string;
  value?: string;
  onChange?: (value?: string) => void;
};

export const SitterSelect = (props: any) => {
  const { selectProps } = useSelect<ISitter>({
    resource: 'sitters',
    optionLabel: 'name',
    meta: {
      fields: ['id', 'name'],
    },
    onSearch: (value) => [
      {
        field: 'name',
        operator: 'contains',
        value,
      },
    ],
  });

  return (
    <Select
      showSearch
      id={props.id}
      placeholder="シッターを選択"
      value={props.value}
      onChange={props.onChange}
      {...selectProps}
    />
  );
};
